import { Http } from '../axios';

export const fetchTermsAndConditions = async (blNumber, anonAddresses) => {
  return await Http.post(`/bills-of-lading/terms/${encodeURIComponent(blNumber)}`, {
    // too big for headers or params, could trigger a 413 Entity Too Large response error (SCRDEV-421)
    includeadr: anonAddresses.join(','),
  })
};